import script from "./YoutubeView.vue?vue&type=script&setup=true&lang=js"
export * from "./YoutubeView.vue?vue&type=script&setup=true&lang=js"

import "./YoutubeView.vue?vue&type=style&index=0&id=582977cb&lang=scss"

const __exports__ = script;

export default __exports__